var pug = require("!../../../../../node_modules/pug-runtime/index.js");

function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<h3 class=\"fm-avant-garde-headline\">Communications Team</h3><p>For questions about press contact:" + (jade.escape(null == (jade_interp = ' ') ? "" : jade_interp)) + "<a href=\"mailto:press@artsy.net\">press@artsy.net</a></p><h3 class=\"fm-avant-garde-headline\">Editorial</h3><p>For pitches and story ideas contact:" + (jade.escape(null == (jade_interp = ' ') ? "" : jade_interp)) + "<a href=\"mailto:pitches@artsy.net\">pitches@artsy.net</a></p>");;return buf.join("");
};
module.exports = template;